var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paySuccess main center"},[_c('Icon',{attrs:{"type":"md-checkmark-circle-outline","size":"60","color":"green"}}),_vm._v(" "),_c('p',{staticClass:"paySuccess-subtitle"},[_vm._v("批改成功")]),_vm._v(" "),_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.detail}},[_vm._v("查看详情")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d83fa1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/haierProduct/components/forklift/editsuccess.vue
// module id = null
// module chunks = 